<ng-template #location let-modal>
  <div class="modal-header d-flex flex-row justify-content-between align-items-center">
    <h2 class="modal-title text-center">{{'browser-attestations-details-modal-location-title' | translate}}</h2>
    <button type="button" class="modal-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <mat-divider></mat-divider>
  <div class="modal-body d-flex flex-column align-items-center">
    <table class="table">
      <tbody>
        <tr>
          <th scope="row">
            <h5>{{'browser-attestations-details-modal-location-latitude' | translate}}</h5>
          </th>
          <td>
            <h5 class="value">{{browserAttestation?.location?.latitude}}</h5>
          </td>
        </tr>
        <tr>
          <th scope="row">
            <h5>{{'browser-attestations-details-modal-location-longitude' | translate}}</h5>
          </th>
          <td>
            <h5 class="value">{{browserAttestation?.location?.longitude}}</h5>
          </td>
        </tr>
        <tr>
          <th scope="row">
            <h5>{{'browser-attestations-details-modal-location-timezone' | translate}}</h5>
          </th>
          <td>
            <h5 class="value">{{browserAttestation?.components?.timezone}}</h5>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-template>

<ng-template #metadataModal let-modal>
  <div class="modal-header">
    <h2 class="modal-title text-center">{{'attestations-title-metadata' | translate}}</h2>
    <button type="button" class="modal-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body justify-content-center">
    <app-commons-modal-part [mapObject]="getMetaData()"></app-commons-modal-part>
  </div>
</ng-template>

<div class="container d-flex flex-column">
  <div class="d-flex flex-row">
    <div class="column section d-flex flex-column userInfos">
      <table class="table">
        <tbody>
          <tr class="sdk">
            <td class="head"><img src="assets/icons/BrowserAttestations/logoWP.png" alt="WP"></td>
            <td class="body">
              <div class="d-flex flex-column align-items-start">
                <h5>{{'browser-attestations-details-sdk-version' | translate}}</h5>
                <h5 class="value">{{browserAttestation?.wpInfo?.wpSdkVersion}}</h5>
              </div>
            </td>
          </tr>
          <tr class="user">
            <td class="head"><img src="assets/icons/person.dark.svg" alt="User"></td>
            <td class="body">
              <div class="d-flex flex-column align-items-start">
                <h5>{{'browser-attestations-details-user-id' | translate}}</h5>
                <h5 class="value">{{browserAttestation?.userId}}</h5>
              </div>
            </td>
          </tr>
          <tr class="app">
            <td class="head">
              <img src="assets/icons/BrowserAttestations/application.svg" alt="App">
            </td>
            <td class="body">
              <h5>{{browserAttestation?.appInfo?.appName | capitalizeWords}}</h5>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="column section d-flex flex-column location">
      <div class="head d-flex flex-row justify-content-between align-items-center">
        <img src="assets/icons/location.svg" alt="Location">
        <span [class]="browserAttestation?.location?.countryCode | flagicon"></span>
      </div>
      <div class="body d-flex flex-column justify-content-around">
        <div class="ginfos d-flex flex-row justify-content-around align-items-center">
          <h5 class="value">{{browserAttestation?.location?.countryCode}}</h5>
          <span class="dot"></span>
          <h5 class="value">{{browserAttestation?.location?.region}}</h5>
          <span class="dot"></span>
          <h5 class="value">{{browserAttestation?.location?.city}}</h5>
        </div>
        <div class="d-flex flex-row justify-content-between align-items-center">
          <h5>{{'browser-attestations-details-ip' | translate}}</h5>
          <h5 class="value">{{browserAttestation?.ip}}</h5>
        </div>
      </div>
      <div class="footer d-flex flex-wrap align-items-center justify-content-center">
        <button class="btn btn-lg btn-outline-primary"
          (click)="open({content : location},'default','locationModal')">{{'see-more' | translate}}</button>
      </div>
    </div>
  </div>
  <div class="section mainInfos d-flex flex-column justify-content-center">
    <div class="deviceInfos d-flex flex-column">
      <div class="head d-flex flex-row justify-content-between">
        <div class="os d-flex flex-row justify-content-around align-items-center">
          <img class="osIcon" src="assets/icons/logosOS/{{browserAttestation?.deviceInfo?.osName?.toLowerCase()}}.svg">
          <h3 class="value">{{browserAttestation?.deviceInfo?.osName}} {{browserAttestation?.deviceInfo?.osVersion}}</h3>
        </div>
        <div class="deviceType d-flex flex-row justify-content-around align-items-center">
          <h3>{{'browser-attestations-details-type' | translate}}</h3>
          <img type="button" placement='top' [ngbTooltip]="browserAttestation?.deviceInfo?.device"
            src="assets/icons/BrowserAttestations/{{browserAttestation?.deviceInfo?.device}}.svg" alt="Device">
        </div>
      </div>
      <div class="body d-flex flex-column align-items-start">
        <div class="d-flex platform flex-row">
          <h5>{{'browser-attestations-details-platform' | translate}}</h5>
          <h5 class="value">{{browserAttestation?.components?.platform}}</h5>
        </div>
        <div class="d-flex userAgent flex-wrap">
          <h5>{{'browser-attestations-details-user-agent' | translate}}</h5>
          <h5 class="value">{{browserAttestation?.deviceInfo?.userAgent}}</h5>
        </div>
      </div>
      <div class="footer d-flex flex-wrap align-items-center justify-content-center">
        <app-modal-browser-attestations [browserAttestation]="browserAttestation"
          [modalRef]="'system'"></app-modal-browser-attestations>
      </div>
    </div>
    <mat-divider></mat-divider>
    <div class="browserInfos d-flex flex-column">
      <div class="head d-flex flex-row justify-content-between">
        <div class="browser d-flex flex-row justify-content-around align-items-center">
          <img class="osIcon"
            src="assets/icons/BrowserAttestations/browsers/{{(browserAttestation?.deviceInfo?.browserName?.toLowerCase()|browser)}}.svg">
          <h3 class="value">{{browserAttestation?.deviceInfo?.browserName}}</h3>
        </div>
        <div class="version d-flex flex-row justify-content-around align-items-center">
          <h3>{{'browser-attestations-details-major-version' | translate}}</h3>
          <h3 class="value">{{browserAttestation?.deviceInfo?.browserMajorVersion}}</h3>
        </div>
      </div>
      <div class="body bodyBrowser d-flex flex-row justify-content-between">
        @if (browserAttestation?.deviceInfo?.browserFullVersion) {
        <div class="d-flex fullVersion flex-wrap justify-content-between">
          <h5>{{'browser-attestations-details-full-version' | translate}}</h5>
          <h5 class="value">{{browserAttestation?.deviceInfo?.browserFullVersion}}</h5>
        </div>
        }
        @if (browserAttestation?.components?.vendor) {
        <div class="d-flex vendor flex-wrap justify-content-between">
          <h5>{{'browser-attestations-details-vendor' | translate}}</h5>
          <h5 class="value">{{browserAttestation?.components?.vendor}}</h5>
        </div>
        }
        @if (browserAttestation?.components?.vendorFlavors && browserAttestation?.components?.vendorFlavors!.length > 0) {
        <div class="d-flex vendorFlavor flex-wrap justify-content-between">
          <h5>{{'browser-attestations-details-vendor-flavor' | translate}}</h5>
          <h5 class="value">{{browserAttestation?.components?.vendorFlavors}}</h5>
        </div>
        }
      </div>
      <div class="footer d-flex flex-wrap align-items-center justify-content-center">
        <app-modal-browser-attestations [browserAttestation]="browserAttestation"
          [modalRef]="'browser'"></app-modal-browser-attestations>
      </div>
    </div>
    <div class="otherDatas d-flex flex-row justify-content-between">
      <div class="section d-flex flex-row align-items-center justify-content-around">
        <h3>{{'browser-attestations-details-metadata' | translate}}</h3>
        <button type="button" class="btn btn-outline-primary"
          (click)="open({content : metadataModal}, 'xl', 'metadataModal')">{{'see' | translate}}</button>
      </div>
      <div class="section d-flex flex-row align-items-center justify-content-around">
        <img src="assets/icons/BrowserAttestations/fingerprint.svg" alt="Metadata">
        <div class="d-flex flex-column align-items-center justify-content-center">
          <h3>{{'browser-attestations-details-confiance' | translate}}</h3>
          <h3 [ngClass]="checkScore(undefined)">Undefined</h3>
        </div>
      </div>
    </div>
  </div>
</div>